import React from 'react';
import * as Styled from './style';

interface Props {
  data: {
    caseTypes: string;
    caseDetails: string;
  };
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  errors: {
    caseTypes?: string;
    caseDetails?: string;
  };

   setErrors: React.Dispatch<React.SetStateAction<any>>;
      handleChange: (
        e:
          | React.ChangeEvent<HTMLInputElement>
          | React.ChangeEvent<HTMLTextAreaElement>
          | React.ChangeEvent<HTMLSelectElement>
      ) => void;
      handleBlur: (
        e:
          | React.ChangeEvent<HTMLInputElement>
          | React.ChangeEvent<HTMLTextAreaElement>
          | React.ChangeEvent<HTMLSelectElement>
      ) => void;
  handleSubmit: (e: React.FormEvent) => void;
  handleBack: () => void;
}

export default function StepSeven({
  data,
  setFormData,
  errors,
  handleSubmit,
  handleBack,
}: Props) {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <Styled.Title>Lead Information</Styled.Title>

      <Styled.Group>
        <Styled.Label>
          What type of cases would you like the chatbot to collect information for?
          <Styled.HelperText>
            (ex: Criminal, Personal Injury, Family, etc…)
          </Styled.HelperText>
        </Styled.Label>
        <Styled.Textarea
          name="caseTypes"
          value={data.caseTypes}
          onChange={handleChange}
        />
        {errors.caseTypes && <Styled.Error>{errors.caseTypes}</Styled.Error>}
      </Styled.Group>

      <Styled.Group>
        <Styled.Label>
          What case specific information would you like the chatbot to collect for each type of law?
        </Styled.Label>
        <Styled.Textarea
          name="caseDetails"
          value={data.caseDetails}
          onChange={handleChange}
        />
        {errors.caseDetails && <Styled.Error>{errors.caseDetails}</Styled.Error>}
      </Styled.Group>

      <Styled.ButtonGroup>
        <Styled.Button type="button" onClick={handleBack}>
          Go back
        </Styled.Button>
        <Styled.Button type="submit" onClick={handleSubmit}>
          Complete form
        </Styled.Button>
      </Styled.ButtonGroup>
    </>
  );
}
